import Reveal from '@/components/feature/Reveal';
import { trendingList, trendingTags } from '@/mocks/home';

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-base text-primary-600" />;
  if (trend === 'down') return <i className="ri-arrow-down-line text-base text-secondary-500" />;
  return <i className="ri-subtract-line text-base text-foreground-400" />;
}

export default function TrendingBoard() {
  return (
    <section id="trending" className="scroll-mt-28 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <Reveal>
          <header className="max-w-2xl">
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-accent-700">
              HOT BOARD
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              今日讨论热度榜
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              综合讨论量、回看率与新增收藏排序，每晚十二点更新。热度越高的话题，越值得先看。
            </p>
          </header>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-8">
            <div className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
              {trendingList.map((item) => {
                const isTop = item.rank <= 3;
                return (
                  <div
                    key={item.rank}
                    className="flex items-center gap-4 border-b border-background-200/60 px-5 py-4 last:border-b-0"
                  >
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                        isTop
                          ? 'bg-accent-500 text-foreground-950'
                          : 'bg-background-100 text-foreground-500'
                      }`}
                    >
                      {item.rank}
                    </span>

                    <div className="min-w-0 flex-1">
                      <h3 className="truncate text-sm font-medium text-foreground-900 md:text-base">
                        {item.title}
                      </h3>
                      <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200/70">
                        <div
                          className={`h-full rounded-full ${isTop ? 'bg-accent-500' : 'bg-secondary-300'}`}
                          style={{ width: `${Math.max(18, 100 - item.rank * 8)}%` }}
                        ></div>
                      </div>
                    </div>

                    <div className="flex w-16 shrink-0 flex-col items-end gap-1">
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {item.heat}
                      </span>
                      <TrendIcon trend={item.trend} />
                    </div>
                  </div>
                );
              })}
            </div>
          </Reveal>

          <Reveal delay={120} className="lg:col-span-4">
            <div className="flex h-full flex-col gap-6">
              <div className="rounded-lg bg-primary-600 p-6 text-background-50">
                <div className="flex items-center gap-2 text-xs text-primary-100">
                  <i className="ri-pulse-line text-base" />
                  当前最热话题
                </div>
                <p className="mt-3 font-heading text-xl font-bold leading-snug">
                  本周讨论热度最高的三个话题合集
                </p>
                <p className="mt-3 text-sm leading-relaxed text-primary-100">
                  9.8 万次浏览 · 1,286 条讨论 · 仍在持续升温
                </p>
                <a
                  href="#discussion"
                  className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  去讨论区看看
                  <i className="ri-arrow-right-line text-base" />
                </a>
              </div>

              <div className="rounded-lg border border-background-200/80 bg-background-50 p-6">
                <h3 className="font-heading text-base font-bold text-foreground-950">热门标签</h3>
                <div className="mt-4 flex flex-wrap gap-2">
                  {trendingTags.map((tag) => (
                    <span
                      key={tag.label}
                      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
                    >
                      {tag.label}
                      <span className="text-secondary-600">{tag.count}</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}